/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createSelector } from 'reselect';

const getProfile = state => state.profile;

export const makeGetUserProfile = () =>
  createSelector(
    [getProfile],
    profile => {
      if (profile.loading) {
        return {
          profile_picture: {},
          role_data: {},
          pictures: {
            polaroids: [],
            portfolio: [],
          },
          ...profile,
        };
      }

      const defaultRole = profile.roles?.default_role;
      const profilePicture = profile.roles
        ? profile.roles[defaultRole].pictures.find(
            picture => picture.is_default
          )
        : null;

      const pictures = profile.roles
        ? profile.roles[defaultRole]?.pictures
        : [];

      const polaroids = [];

      // Assign each existing polaroid to it's designated index.
      pictures
        .filter(picture => picture.index < 3)
        .forEach(picture => {
          polaroids[picture.index] = picture;
        });

      // Portfolio pictures will always be the rest of the images (from index 3 and up).
      const portfolio = [];

      // Assign each existing portfolio to it's designated index.
      pictures
        .filter(picture => picture.index > 2)
        .forEach(picture => {
          portfolio[picture.index] = picture;
        });

      return {
        profile_picture: profilePicture,
        role_data: profile.roles
          ? {
              ...profile.roles[defaultRole],
            }
          : {},
        pictures: {
          polaroids,
          portfolio,
        },
        ...profile,
      };
    }
  );
